import { styled } from '@mui/material/styles';
import { DateFieldProps, DateField as RaDateField } from 'react-admin';

const StyledDateField = styled(RaDateField, { slot: 'Root' })(() => ({}));

function DateField({ variant = 'body1', ...props }: DateFieldProps): JSX.Element {
  // @ts-ignore
  return <StyledDateField {...props} variant={variant} />;
}

export { DateField };
export type { DateFieldProps };
